import { render } from "./AdditionalMenuMeetings.vue?vue&type=template&id=f2a631dc&scoped=true"
import script from "./AdditionalMenuMeetings.vue?vue&type=script&lang=js"
export * from "./AdditionalMenuMeetings.vue?vue&type=script&lang=js"

import "./AdditionalMenuMeetings.vue?vue&type=style&index=0&id=f2a631dc&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a631dc"]])

export default __exports__